export const initialState = {
    packageInfo: [],
    isFetching: false,
    isError: false
};

export const urls = {
    getPackagesInfo: () => '/api/catalog/getPremiumPackages'
};

export const TYPE = 'USER_PREMIUM_PACKAGES_INFO';

export default (state = initialState, action) => {
    switch (action.type) {
        case `REQUEST_${TYPE}`: {
            return {
                packageInfo: [],
                isFetching: true,
                isError: false
            };
        }
        case `RECEIVE_${TYPE}`: {
            return {
                packageInfo: action.data?.data?.packageInfo || [],
                isFetching: false,
                isError: false
            };
        }
        case `ERROR_${TYPE}`: {
            return {
                packageInfo: [],
                isFetching: false,
                isError: true
            };
        }
        default:
            return state;
    }
};
